(() => {
  'use strict';
  const permitted = (stock, items, id, requested, excludedKey) => {
    const existing = items.filter(item => String(item.variant_id || item.id) === String(id) && item.key !== excludedKey)
      .reduce((sum, item) => sum + Number(item.quantity), 0);
    let limit = stock.maximum == null ? Infinity : Number(stock.maximum);
    if (stock.tracked && stock.policy === 'deny') limit = Math.min(limit, Math.max(0, stock.stock));
    if (!stock.available) limit = 0;
    return Number.isInteger(requested) && requested >= 0 && existing + requested <= limit;
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = { permitted }; return; }
  let queue = Promise.resolve();
  const run = task => {
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result;
  };
  const root = () => window.Shopify?.routes?.root || '/';
  const readCart = async () => {
    const response = await fetch(`${root()}cart.js`, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error(window.chdCartCopy.error);
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error(window.chdCartCopy.error);
    return cart;
  };
  const readStock = async id => {
    if (!/^\d+$/.test(String(id))) throw new Error(window.chdCartCopy.invalid_quantity);
    const resolved = await fetch(`${root()}variants/${id}`, { method: 'HEAD', credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!resolved.ok) throw new Error(window.chdCartCopy.error);
    const url = new URL(resolved.url);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error(window.chdCartCopy.error);
    url.searchParams.set('variant', id);
    url.searchParams.set('section_id', 'chd-stock');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error(window.chdCartCopy.error);
    const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-chd-stock]');
    const stock = node && JSON.parse(node.textContent);
    if (!stock || String(stock.id) !== String(id) || !Number.isInteger(stock.stock)) throw new Error(window.chdCartCopy.error);
    return stock;
  };
  const notify = text => {
    const nodes = [...document.querySelectorAll('[data-chd-cart-feedback]')].filter(node => node.getClientRects().length);
    nodes.forEach(node => { node.textContent = text; node.hidden = false; node.classList.add('is-error'); node.setAttribute('role', 'alert'); });
    if (!nodes.length) window.alert(text);
  };
  const requestAdd = (url, options) => run(async () => {
    try {
      const body = typeof options.body === 'string' ? JSON.parse(options.body) : Object.fromEntries(options.body);
      const items = body.items || [body];
      const totals = new Map();
      items.forEach(item => {
        const quantity = Number(item.quantity ?? 1);
        if (!Number.isInteger(quantity) || quantity <= 0) throw new Error(window.chdCartCopy.invalid_quantity);
        totals.set(String(item.id), (totals.get(String(item.id)) || 0) + quantity);
      });
      const [cart, stocks] = await Promise.all([readCart(), Promise.all([...totals.keys()].map(readStock))]);
      for (const stock of stocks) {
        if (!permitted(stock, cart.items, stock.id, totals.get(String(stock.id)))) {
          throw new Error(`${window.chdCartCopy.invalid_quantity} ${stock.message}`);
        }
      }
      return await fetch(url, options);
    } catch (error) {
      const description = error.message || window.chdCartCopy.error;
      notify(description);
      return new Response(JSON.stringify({ status: 422, description }), { status: 422, headers: { 'Content-Type': 'application/json' } });
    }
  });
  window.chdStock = { run, readCart, readStock, permitted, requestAdd };
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-chd-offer-add')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname) || !url.searchParams.has('id')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (link.dataset.chdStockBusy) return;
    link.dataset.chdStockBusy = 'true'; link.setAttribute('aria-busy', 'true');
    try {
      const response = await requestAdd(`${root()}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.fromEntries(url.searchParams)) });
      if (response.ok) location.assign(`${root()}cart`);
    } finally { delete link.dataset.chdStockBusy; link.removeAttribute('aria-busy'); }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.chdStockBusy) return;
    form.dataset.chdStockBusy = 'true';
    try {
      const response = await requestAdd(`${root()}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.fromEntries(new FormData(form))) });
      if (response.ok) location.assign(`${root()}cart`);
    } finally { delete form.dataset.chdStockBusy; }
  }, true);
})();
